<script>
  import { chatState } from '../js/state.js';
  let map = {
    smile: '😀',
    love: '😍',
    shocked: '🤯',
    sad: '😢',
    angry: '😡',
  };
  let width = 100;
</script>

<style>
  @keyframes floatUp {
    from {
      -webkit-transform: translateY(30px);
      transform: translateY(30px);
      opacity: 1;
    }
    to {
      -webkit-transform: translateY(-300px);
      transform: translateY(-300px);
      opacity: 0;
    }
  }

  .reaction-display {
    /* position: absolute; */
    /* bottom: 0;
    left: 0; */
  }

  .reaction-pop {
    position: absolute;
    animation-name: floatUp;
    animation-duration: 4s;
    animation-iteration-count: 1;
    -webkit-transform: translateY(30px);
    transform: translateY(30px);
    pointer-events: none;
  }
</style>

<div class="reaction-display" bind:clientWidth={width}>
  {#each $chatState.reactions as reaction (reaction.id)}
    {#if reaction && reaction.payload && reaction.payload.reaction && map[reaction.payload.reaction]}
      <div class="reaction-pop" style="margin-left: {Math.random() * width}px">
        {map[reaction.payload.reaction]}
      </div>
    {/if}
  {/each}
</div>
